import { HIGHLIGHT_DELETE_INTENT_CLASS } from '@databases/highlights/constants';

import { createEffect } from '../utils/create-effect';

const APP_CONTAINER_ID = 'app';

export const createDeleteIntentHighlightEffect = createEffect(() => ({
  deltaTypes: ['previewSelectionAction'] as const,

  dispose() {
    document
      .getElementById(APP_CONTAINER_ID)
      ?.classList.remove(HIGHLIGHT_DELETE_INTENT_CLASS);
  },

  onDelta(delta) {
    const container = document.getElementById(APP_CONTAINER_ID);

    if (!container) {
      return;
    }

    if (delta.intent === 'delete') {
      container.classList.add(HIGHLIGHT_DELETE_INTENT_CLASS);
    } else {
      container.classList.remove(HIGHLIGHT_DELETE_INTENT_CLASS);
    }
  },
}));
